
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wallet/desktop",
      function () {
        return require("private-next-pages/wallet/desktop/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wallet/desktop"])
      });
    }
  